import { HelpCircleFilled } from '@creditornot/cb-icons';
import { colors, typographyCss } from '@creditornot/cb-ingredients';
import { Tooltip } from '@creditornot/cb-popover';
import { cssThemedValue } from '@creditornot/cb-sc-utils';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

export type CampaignFormItemLayoutProps = {
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  value: ReactNode;
  tooltip?: ReactNode;
  className?: string;
};

const CampaignFormItemContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;
`;

const TopRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const TitleBlock = styled.div`
  margin-block-end: 4px;
`;

const Title = styled.h3`
  ${typographyCss.Heading6()}
  margin: 0;
`;

const Subtitle = styled.p`
  ${typographyCss.Body3()}
  margin: 0;
`;

const InfoIcon = styled(HelpCircleFilled).attrs({
  width: 12,
  height: 12,
})`
  fill: ${cssThemedValue({ light: colors.pepper24, dark: colors.salt28 })};
  margin-inline-start: 8px;
`;

const CampaignFormItemLayout = ({
  title,
  subtitle,
  action,
  tooltip,
  value,
  className,
}: CampaignFormItemLayoutProps) => (
  <CampaignFormItemContainer className={className}>
    {(title || tooltip) && (
      <TopRow>
        <TitleBlock>
          <Title>
            {title}
            {tooltip && (
              <Tooltip content={tooltip}>
                <InfoIcon />
              </Tooltip>
            )}
          </Title>
          {!!subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleBlock>
        {action}
      </TopRow>
    )}
    {value}
  </CampaignFormItemContainer>
);

export default CampaignFormItemLayout;
